import { useEffect } from "react";
import { buildRedirectWithUTM } from "../context/UTM";

/**
 * Hook that intercepts all internal link clicks and preserves UTM parameters
 * Usage: Add this hook to your main App component or router wrapper
 */
export const useUTMPreservation = () => {
  useEffect(() => {
    const handleClick = (e) => {
      // Get the clicked element or closest anchor
      const anchor = e.target.closest("a");

      if (!anchor) return;

      const href = anchor.getAttribute("href");

      // Skip if no href or it's an external link, hash, or special protocol
      if (
        !href ||
        href.startsWith("http://") ||
        href.startsWith("https://") ||
        href.startsWith("#") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:") ||
        anchor.getAttribute("target") === "_blank"
      ) {
        return;
      }

      // Skip if the link already has query parameters (might be intentional)
      if (href.includes("?")) {
        return;
      }

      // Check if there are any UTM parameters in the current URL
      const currentParams = new URLSearchParams(window.location.search);
      const hasUTMParams = Array.from(currentParams.keys()).some(
        (key) =>
          key.startsWith("utm_") ||
          key === "fbclid" ||
          key === "gclid" ||
          key === "gbraid" ||
          key === "gad_source" ||
          key === "gad_campaignid"
      );

      // Only intercept if we have UTM parameters to preserve
      if (!hasUTMParams) {
        return;
      }

      // Prevent default navigation and add UTM parameters
      e.preventDefault();
      const newHref = buildRedirectWithUTM(href);
      window.location.href = newHref;
    };

    // Add click listener to document
    document.addEventListener("click", handleClick, true);

    // Cleanup
    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, []);
};
